import React, { useState, useEffect, useMemo } from "react";
import moment from "moment";
import "./Profile.css";
import { Link, useNavigate } from "react-router-dom";
import ChangePasswordPopup from "../../Components/ChangePasswordPopup";
import ChangePinPopup from "../../Components/ChangePinPopup";
import SimplePopup from "../../Components/SimplePopup";
import Header from "../../Components/Header";
import {
  fetchProfile,
  profileImgPreview,
  updatePassword,
  updatePin,
  retriveLoginActivityService,
} from "../../Services/profile/profileservice";
import Seo from "../../Components/SeoComponent/Seo";
import { FaInbox } from "react-icons/fa";
import PaginationData from "../../Components/PaginationData";

export default function Profile() {
  const [profile, setProfile] = useState({});
  const [isChecked, setIsChecked] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showPinModal, setShowPinModal] = useState(false);
  const [showSamplePopup1, setshowSamplePopup1] = useState(false);
  const [showSamplePopup2, setshowSamplePopup2] = useState(false);
  const [showSamplePopup3, setshowSamplePopup3] = useState(false);
  const [showSamplePopup4, setshowSamplePopup4] = useState(false);
  const [profileImg, setProfileImg] = useState("");
  const [loginActivityData, setLoginActivityData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [paginationData, setPaginationData] = useState();
  const [filename, setFilename] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const loadProfile = async () => {
      setLoading(true);
      try {
        const data = await fetchProfile();
        const profileData = {
          ...data.data,
          companyType: data.data?.companyType || "Default Company Type",
        };

        if (data.data?.status_id === 1 || data.data?.status_id === 17) {
          navigate("/CompleteProfile");
          return;
        }
        if (data && (data.company_details || profileData)) {
          setProfile(profileData);
          setFilename(data.profile || "Default Filename");
        } else {
          console.error("Company details are missing in the profile data");
          setError("Company details are missing in the profile data");
        }
      } catch (error) {
        console.error("Failed to load profile:", error.message);
        setError("Failed to load profile");
      } finally {
        setLoading(false);
      }
    };

    loadProfile();
  }, []);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleUpdatePassword = async (newPassword) => {
    try {
      await updatePassword(newPassword);
      setShowModal(false);
    } catch (error) {
      console.error("Failed to update password:", error);
    }
  };

  const handleUpdatePin = async (newPin) => {
    try {
      await updatePin(newPin);
      setShowPinModal(false);
    } catch (error) {
      console.error("Failed to update PIN:", error);
    }
  };

  useEffect(() => {
    const PreviewImg = async () => {
      // if (!filename) {
      //   console.warn('Filename is undefined or empty');
      //   return;
      // }
      try {
        const response = await profileImgPreview({ filename });
        setProfileImg(response.dataUri);
      } catch (error) {
        console.error("Error fetching image:", error);
      }
    };
    PreviewImg();
  }, [filename]);
  //ENd

  // Retrive Login Activity Data Function
  const RetriveLoginActivityData = async (page = currentPage) => {
    try {
      const response = await retriveLoginActivityService(page);
      setLoginActivityData(response.data.data || []);

      setPaginationData(response.data.pagination || {});
      setCurrentPage(response.data.pagination.current_page || 1);
      setLastPage(response.data.pagination.last_page || 1);
    } catch (error) {
      console.error("Error fetching Login data:", error);
    }
  };

  useEffect(() => {
    RetriveLoginActivityData();
  }, []);
  // ENd

  function handlePage(page) {
    setCurrentPage(page);
  }

  // Date Time Formate Show
  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  // ENd

  return (
    <>
      <Seo />
      <ChangePasswordPopup
        showModal={showModal}
        setShowModal={setShowModal}
        onUpdatePassword={handleUpdatePassword}
      />
      <ChangePinPopup
        showPinModal={showPinModal}
        setShowPinModal={setShowPinModal}
        onUpdatePin={handleUpdatePin}
      />

      <Header heading="Profile" />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-3">
        <div className="standard-box-shadow rounded-md p-2">
          <div className="flex flex-col">
            {loading ? (
              <p className="text-black">Loading...</p>
            ) : (
              <>
                <img
                  className="w-40 rounded-full h-40 m-auto text-black"
                  src={profileImg}
                  alt="Profile"
                />
                {!profileImg && <p className="text-black">Loading....</p>}
              </>
            )}

            <h1 className="text-center  mt-2 font-bold text-black">
              {profile?.name}
            </h1>
            <p className="text-center text-gray-500 font-medium">
              Pan&nbsp;&nbsp;:&nbsp;&nbsp;
              {profile?.pan_number &&
                profile?.pan_number?.slice(0, 3) +
                  "●●●●" +
                  profile?.pan_number?.slice(-3)}
            </p>
            <p className="text-center text-gray-500 font-medium">
              Aadhar&nbsp;&nbsp;:&nbsp;&nbsp;
              {profile?.aadhar_number &&
                profile?.aadhar_number?.slice(0, 3) +
                  "●●●●●●" +
                  profile?.aadhar_number?.slice(-3)}
            </p>
            <p className="text-center text-gray-500 font-medium">
              Email&nbsp;&nbsp;:&nbsp;&nbsp;{profile?.email_address}
            </p>
            <hr className="my-2" />
            <div className="grid grid-cols-5">
              <p className="col-span-2 text-gray-400 font-bold">Joining Date</p>
              <p className="col-span-3 text-gray-600">
                :&nbsp;&nbsp;{moment(profile?.doc).format("YYYY-MM-DD")}
              </p>
              <p className="col-span-2 text-gray-400 font-bold">Updated Date</p>
              <p className="col-span-3 text-gray-600">
                :&nbsp;&nbsp;{moment(profile?.updated_at).format("YYYY-MM-DD")}
              </p>
              <p className="text-gray-400 font-bold">Address</p>
              <p className="col-span-4 text-gray-600">
                :&nbsp;&nbsp;{profile?.landmark_address}
              </p>
            </div>
            <hr className="my-2" />
            <h1 className="text-gray-400 font-bold">KYC Details</h1>
            <div className="flex gap-5">
              <span
                onClick={() => setshowSamplePopup1(true)}
                className="text-gray-700 underline cursor-pointer"
              >
                Pan
              </span>
              <span
                onClick={() => setshowSamplePopup2(true)}
                className="text-gray-700 underline cursor-pointer"
              >
                Aadhar
              </span>
              <span
                onClick={() => setshowSamplePopup3(true)}
                className="text-gray-700 underline cursor-pointer"
              >
                Photo
              </span>
              <span
                onClick={() => setshowSamplePopup4(true)}
                className="text-gray-700 underline cursor-pointer"
              >
                Bank Cheque
              </span>
            </div>
          </div>
        </div>

        {profile && (
          <div className="col-span-1 md:col-span-2 standard-box-shadow rounded-md p-2">
            <h1 className="font-bold text-xl text-gray-500 flex items-center justify-between w-full">
              <span>
                Company Name: {profile?.company_details?.company_name}
              </span>

              <Link
                to="/CompleteProfile"
                className="text-md bg-blue-600 text-white px-1 py-1 rounded-md hover:bg-blue-700"
              >
                Complete Profile
                <span className="text-red-600 animate-scrollUp text-xs mt-1">
                  New
                </span>
              </Link>
            </h1>

            <hr className="my-2" />

            <div className="grid grid-cols-1 sm:grid-cols-4 justify-center items-center">
              <p className="text-xl font-bold text-gray-500">CIN</p>
              <p className="col-span-3 text-gray-600">
                :&nbsp;&nbsp;
                {profile?.company_details?.company_cin
                  ? profile?.company_details?.company_cin?.slice(0, 4) +
                    "●●●●●●●●●●" +
                    profile?.company_details?.company_cin?.slice(-4)
                  : ""}
              </p>

              <p className="text-xl font-bold text-gray-500">GST No</p>
              <p className="col-span-3 text-gray-600">
                :&nbsp;&nbsp;
                {profile?.company_details?.company_gst_no
                  ? profile?.company_details?.company_gst_no?.slice(0, 4) +
                    "●●●●●●●●●●" +
                    profile?.company_details?.company_gst_no?.slice(-4)
                  : ""}
              </p>

              <p className="text-xl font-bold text-gray-500">
                Company Category
              </p>
              <p className="col-span-3 text-gray-600">
                :&nbsp;&nbsp;
                {profile?.company_details?.company_type?.name || ""}
              </p>

              <p className="text-xl font-bold text-gray-500">Company Address</p>
              <p className="col-span-3 text-gray-600">
                :&nbsp;&nbsp;{profile?.company_details?.company_address || ""}
              </p>
            </div>

            <hr className="my-2" />

            <div className="flex flex-col gap-3 mt-8">
              <div className="flex justify-between items-center">
                <div>
                  <h1 className="text-xl font-bold text-gray-600">
                    Login Password
                  </h1>
                  <p className="italic">
                    {moment(profile?.updated_at).format("YYYY-MM-DD")}
                  </p>
                </div>
                <button
                  onClick={() => setShowModal(true)}
                  className="btn py-1 px-3 border transition-all rounded hover:bg-blue-400 hover:text-white border-blue-400"
                >
                  Change
                </button>
              </div>

              <div className="flex justify-between items-center">
                <div>
                  <h1 className="text-xl font-bold text-gray-600">iPIN</h1>
                  <p className="italic">
                    {moment(profile?.updated_at).format("YYYY-MM-DD")}
                  </p>
                </div>
                <button
                  onClick={() => setShowPinModal(true)}
                  className="btn py-1 px-3 border transition-all rounded hover:bg-blue-400 hover:text-white border-blue-400"
                >
                  Change
                </button>
              </div>

              <div className="flex justify-between items-center">
                <div>
                  <h1 className="text-xl font-bold text-gray-600">
                    Lock Screen
                  </h1>
                  <p className="italic">Never Changed</p>
                </div>

                <label className="inline-flex relative items-center cursor-pointer">
                  <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer-checked:after:translate-x-full after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:h-5 after:w-5 after:rounded-full after:transition-all peer-checked:bg-blue-600"></div>
                </label>
              </div>
            </div>
          </div>
        )}
      </div>
      {loginActivityData && loginActivityData.length > 0 ? (
        <>
          {/* TABLE for Desktop */}
          <div className="overflow-x-auto my-1 p-1 hidden md:block">
            <table className="min-w-full divide-y divide-gray-200 shadow-md rounded-lg">
              <thead className="text-sm text-white bg-blue-600">
                <tr>
                  <th scope="col" className="p-2 text-left border">
                    Activity_ID
                  </th>
                  <th scope="col" className="p-2 text-left border">
                    Timestamp
                  </th>
                  <th scope="col" className="p-2 text-left border">
                    Lat/Long
                  </th>
                  <th scope="col" className="p-2 text-left border">
                    Activity
                  </th>
                  <th scope="col" className="p-2 text-left border">
                    Device
                  </th>
                  <th scope="col" className="p-2 text-left border">
                    Source_IP
                  </th>
                </tr>
              </thead>
              <tbody className="text-center bg-white divide-y divide-gray-100">
                {loginActivityData.map((item, index) => (
                  <tr key={index} className="border border-b hover:bg-gray-50">
                    <td className="p-1 border font-bold">
                      {(currentPage - 1) * paginationData?.per_page + index + 1}
                    </td>
                    <td className="p-1 font-medium border">
                      {formatDate(item.updated_at)}
                    </td>
                    <td className="p-1 font-medium border">
                      {item.latitude}/{item.longitude}
                    </td>
                    <td className="p-1 font-medium border">
                      {item.loggedin ? "Login" : "Logout"}
                    </td>
                    <td
                      className="p-1 font-medium border max-w-[150px] truncate"
                      title={item.device_id}
                    >
                      {item.device_id}
                    </td>
                    <td className="p-1 font-medium border">
                      {item.ip_address}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* CARDS for Mobile */}
          <div className="block md:hidden space-y-1 my-1">
            {loginActivityData.map((item, index) => (
              <div
                key={index}
                className="bg-white shadow-md rounded-lg p-1 border border-gray-200"
              >
                <div className="flex justify-between items-center mb-2">
                  <span className="text-sm font-bold text-blue-600">
                    {(currentPage - 1) * paginationData?.per_page + index + 1}
                  </span>
                  <span className="text-xs text-gray-500">
                    {formatDate(item.updated_at)}
                  </span>
                </div>
                <div className="text-gray-700 text-sm">
                  <p>
                    <span className="font-semibold">Activity:</span>{" "}
                    {item.loggedin}
                  </p>
                  <p>
                    <span className="font-semibold">Device:</span>{" "}
                    {item.device_id}
                  </p>
                  <p>
                    <span className="font-semibold">IP:</span> {item.ip_address}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <div className="flex items-center mt-2 gap-1 text-lg text-neutral-600 justify-center">
          <FaInbox className="text-blue-700 text-2xl" />
          <p className="flex justify-center items-center">Data not found</p>
        </div>
      )}
      <PaginationData
        currentPage={currentPage}
        lastPage={lastPage}
        handlePage={handlePage}
      />

      <SimplePopup
        showSamplePopup={showSamplePopup1}
        setshowSamplePopup={setshowSamplePopup1}
        title="Pan"
        body={<img className="mx-auto" src={profile?.pan_image} alt="pan" />}
      />
      <SimplePopup
        showSamplePopup={showSamplePopup2}
        setshowSamplePopup={setshowSamplePopup2}
        title="Adhar"
        body={
          <img className="mx-auto" src={profile?.aadhar_image} alt="adhar" />
        }
      />
      <SimplePopup
        showSamplePopup={showSamplePopup3}
        setshowSamplePopup={setshowSamplePopup3}
        title="Photo"
        body={<img className="mx-auto" src={profile?.image} alt="user pic" />}
      />
      <SimplePopup
        showSamplePopup={showSamplePopup4}
        setshowSamplePopup={setshowSamplePopup4}
        title="Bank Cheque"
        body={<img className="mx-auto" src="" alt="bank cheque" />}
      />
    </>
  );
}
